import { AgremoAnalysis } from '../data-models/agremo-analysis.model';
import { AgremoMapStatus } from '../data-models/agremo-map-status.model';
import { isRecord } from '../utils/is-record';
import { nullableString } from '../utils/wire-value-utils';
import { AgremoAnalysisFile } from './agremo-analysis-file.model';

/** GET /admin/agremo/analyses/:id: the analysis plus its map and result files (with signed download URLs). */
export class AgremoAnalysisDetail extends AgremoAnalysis {
  mapStatus?: AgremoMapStatus | null;
  mapName?: string | null;
  files: AgremoAnalysisFile[];

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.mapStatus = nullableString(source['mapStatus']) as AgremoMapStatus | null | undefined;
    this.mapName = nullableString(source['mapName']);
    this.files = Array.isArray(source['files']) ? source['files'].filter(isRecord).map(toFile) : [];
  }
}

function toFile(source: Record<string, unknown>): AgremoAnalysisFile {
  return {
    id: nullableString(source['id']) ?? '',
    analysisId: nullableString(source['analysisId']) ?? '',
    fileType: nullableString(source['fileType']) ?? '',
    agremoUrl: nullableString(source['agremoUrl']) ?? null,
    adnUrl: nullableString(source['adnUrl']) ?? null,
    downloadStatus: nullableString(source['downloadStatus']) ?? '',
    downloadedAt: nullableString(source['downloadedAt']) ?? null,
    downloadUrl: nullableString(source['downloadUrl']) ?? null,
  };
}
